import React, { useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { useAuth } from './hooks/auth-provider';
import NetworkStatus from './utilities/NetworkStatus';

import i18n from './i18n';

// use REACT_APP_SHORT_NAME from .env
const REACT_APP_SHORT_NAME = process.env.REACT_APP_SHORT_NAME || 'SIMPLE BOOKING';

const AppTopbar = (props) => {
    const navigate = useNavigate();

    const onTopbarItemClick = (event, item) => {
        if (props.onTopbarItemClick) {
            props.onTopbarItemClick({
                originalEvent: event,
                item: item
            });
        }
    };

    // get curent user
    const { login, isLoggedin, logout, getCurrentUser, getCSRFToken } = useAuth();

    const onQrIconClick = (event, item) => {
        if (props.onQrIconClick) {
            props.onQrIconClick({
                originalEvent: event,
                item: item
            });
        }
    };

    const onLogout = () => {
        logout().then((res) => {
            navigate('/login');
        });
    };

    const curentUser = getCurrentUser();

    // onScanedDialogOpen    handler

    return (
        <div className="layout-topbar" style={{ backgroundColor: '#007AAE' }}>
            {/* <button type="button" className="p-link layout-right-panel-button layout-topbar-icon" onClick={props.onRightMenuButtonClick}>
                <i className="pi pi-ellipsis-v"></i>
            </button> */}

            <button type="button" className="p-link layout-menu-button layout-topbar-icon" onClick={props.onMenuButtonClick}>
                <i className="pi pi-bars"></i>
            </button>

            <button type="button" className="p-link layout-topbar-logo " onClick={() => navigate('/')}>
                {/* <i className=" topbar-icon pi  pi-fw pi-home text-white text-xl mr-2  "></i> */}
                <span className="text-white text-2xl">
                    {REACT_APP_SHORT_NAME}
                    {/* <NetworkStatus /> */}
                </span>
            </button>

            {/* <span className="layout-topbar-search">
                <i className="pi pi-qrcode"></i>
                <input type="text" placeholder="Enter your search term" onChange={handleScan} />
            </span> */}

            <ul className="topbar-menu">
                <li className={classNames('user-profile', { 'active-topmenuitem fadeInDown': props.activeTopbarItem === 'profile' })}>
                    {curentUser && (
                        <button type="button" className="p-link" onClick={(e) => onTopbarItemClick(e, 'profile')}>
                            <div className="layout-profile-userinfo">
                                <span className="layout-profile-name">{curentUser.ime}</span>
                                <span className="layout-profile-role">{curentUser.title}</span>
                            </div>
                        </button>
                    )}

                    <ul className="fadeInDown">
                        <li role="menuitem">
                            <button type="button" className="p-link" onClick={onLogout}>
                                <i className="pi pi-fw pi-user"></i>
                                <span>Logout</span>
                            </button>
                        </li>
                    </ul>
                </li>
                {/* <li className={classNames('user-profile')}>
                    <button type="button" className="p-link layout-topbar-icon" onClick={(e) => onQrIconClick(e, 'settings')}>
                        <i className="topbar-icon pi pi-fw pi-qrcode  text-3xl "></i>
                    </button>
                </li> */}

                {/* 
                <li className={classNames({ 'active-topmenuitem  fadeInDown': props.activeTopbarItem === 'enalog' })}>
                    <button type="button" className="p-link layout-topbar-icon mr-2" onClick={(e) => onScanedDialogOpen(e, 'enalog')}>
                        <i className="topbar-icon pi pi-fw pi-desktop "></i>
                    </button>
                    <ul className="fadeInDown">
                        <li role="menuitem">
                            <button type="button" className="p-link">
                                <img src="assets/layout/images/avatar-1.png" alt="roma-react" />
                                <div className="topbar-menu-info">
                                    <span className="topbar-menu-name">Nikola Tomić</span>
                                    <span className="topbar-menu-role">User interface review is done.</span>
                                </div>
                            </button>
                        </li>
                    </ul>
                </li> */}
            </ul>
        </div>
    );
};

export default AppTopbar;
